import HotTable from '@handsontable/react';
import React, { useMemo } from 'react'
import{useEffect,useRef,useState} from 'react'
import axios from 'axios';
import { registerRenderer, textRenderer } from 'handsontable/renderers';
import {DataGrid} from '@mui/x-data-grid'
import '../App.css'
import { Box, Typography } from '@mui/material';
import MaterialTable from '@material-table/core';
import { createTheme } from '@mui/material';
import  { ExportCsv, ExportPdf } from '@material-table/exporters';

const Highlow = () => {
  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
    const url3 = "https://app.sheetlabs.com/COCO/highlow"
    // get api
    const getapi = async ()=>{
      
      try{
        const response= await axios.get(url3)
        setData(response.data)
        
      }catch(error){
        console.log(error);
      }

    }

    useEffect(() => {
  
      getapi();

      
    }, [])
   
    
 
    
  
    const columns = [
     
      {title:'Stock',field:'Stock',width:200},
      {title:'Sector',field:'Sector',width:200},
      {title:'P/E',field:'PE',width:200},
      {title:'LTP Today',field:'LTPToday',width:200},
      {title:'52 week high',field:'52weekhigh',width:200},
      {title:'52 week low',field:'52weeklow',width:150},
      {title:'Fall from 52 week high',field:'Fallfrom52weekhigh',width:150},
      {title:'Support',field:'Support',width:150},
      {title:'Resistance',field:'Resistance',width:150},
      {title:'Buy',field:'Buy',width:150},
      {title:'Distance from Support',field:'DistancefromSupport',width:150},
      {title:'Distance from Resistance',field:'DistancefromResistance',width:150},
    ]
   

    // Styling table
    
      
  return (
    <div className="container mt-5 ">
     
     <MaterialTable
      title="52HIGHLOW"
      data={data}
      columns={columns}
      
      options={{
        filtering: true, 
        headerStyle: {
          backgroundColor: '#43A047',
          color: '#FFF',
        },
        columnsButton:true,
        rowStyle: rowData => ({
          backgroundColor: (selectedRow === rowData.tableData.id) ? '#EEE' : '#FFF'
        }),
        tableLayout: 'fixed',
        exportMenu: [{
          label: 'Export PDF',
          exportFunc: (cols, datas) => ExportPdf(cols, datas, 'myPdfFileName')
        }, {
          label: 'Export CSV',
          exportFunc: (cols, datas) => ExportCsv(cols, datas, 'myCsvFileName')
        }]      
        }}>

      </MaterialTable>
     
      
    </div>
    

   
   
  )
}

export default Highlow